import axios from 'axios'
import qs from 'qs' 
import {Toast} from 'vant'
import codeConfig from '@/config/request-code'

// 获取语言配置
let langConfig = sessionStorage.getItem('langConfig')
let langObj = JSON.parse(langConfig)

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // post方法将JSON格式参数以formData形式提交
    if (config.dataType === 'form') {
      config.data = qs.stringify(config.data)
      delete config.dataType
    }
    return config
  },
  (error) => {
    console.log(error) //for debug
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(response=>{
  if (!langConfig) {
    langConfig = sessionStorage.getItem('langConfig')
    langObj = JSON.parse(langConfig)
  }

  const res = response.data
  if (res.ip) {
    return res
  }
  if (res.code === 200 || res.code === 0 || res.code === 203) {
    return res
  } else {
    if (res.code === 2) {
      Toast.fail({
        message: langObj[codeConfig[res.code]]+ ' '+res.msg,
        duration: 5000
      })
    } else {
      Toast.fail({
        message: langObj[codeConfig[res.code]],
        duration: 5000
      })
    }
    return Promise.reject(new Error(res.msg || 'Error'))
  }
}, error => {
  if (!langConfig) {
    langConfig = sessionStorage.getItem('langConfig')
    langObj = JSON.parse(langConfig)
  }
  if (error.message.includes('timeout')) {
    Toast.fail(langObj['Timeout'])
  }
  return Promise.reject(new Error(error))
})

export default service